// extracted by mini-css-extract-plugin
module.exports = {"home":"index_home__23Ubr","left":"index_left__2Vc8S","right":"index_right__jOWvx"};